import { FunnelsGrid } from "./funnels/FunnelsGrid";
import type { DateRange, FunnelSortKey, FunnelSyncFilter } from "./funnels/types";
import type { Period } from "../funnel-detail/types";
import { ChatLayoutWrapper, type ChatContext } from "../ai-chat";

interface FunnelsTabProps {
  dateRange: DateRange;
  period: Period;
  sortBy: FunnelSortKey;
  syncFilter: FunnelSyncFilter;
  onRegisterExport?: (handler: (() => void) | null) => void;
}

export const FunnelsTab = ({
  dateRange,
  period,
  sortBy,
  syncFilter,
  onRegisterExport,
}: FunnelsTabProps) => {
  const chatContext: ChatContext = {
    surface: "funnels",
    period: {
      id: period.id,
      label: period.label,
      from: period.from.toISOString().slice(0, 10),
      to: period.to.toISOString().slice(0, 10),
      days: period.days,
    },
    summary: `Fluxi Finance Embudos\nPeriodo: ${period.label}`,
  };

  return (
    <ChatLayoutWrapper context={chatContext}>
      <FunnelsGrid
        dateRange={dateRange}
        period={period}
        sortBy={sortBy}
        syncFilter={syncFilter}
        onRegisterExport={onRegisterExport}
      />
    </ChatLayoutWrapper>
  );
};
